import { graphql } from 'react-relay';

export const TaskShortFragment = graphql`
    fragment TaskShortFragment on Task {
        id
        name
        color
        datetime
        start_datetime
        start_format_datetime
        end_datetime
        schedule_item_id
        assignee_for_task
        project_id
        owner_task_id
        type
        status
        sub_status
        start_format_datetime
        end_format_datetime
        duration

        description
        priority
        number
        subtask
        phase_id
        division_id
        cost_code_id
        contract_invoice
        wo_si
        value_total
        value_equipment
        value_labour
        value_material
        value_other
    }
`;
